<template>
  <b-card-code title="" no-body>
    <!-- Filter -->
    <b-card-body>
      <div class="d-flex justify-content-between flex-wrap align-items-center">
        <div class="d-flex flex-wrap align-items-end">
          <div>
            <!-- basic -->
            <b-form-group label="Cari" label-for="basicInput" class="mb-0">
              <b-form-input id="basicInput" placeholder="Search" v-model="search" />
            </b-form-group>
          </div>
          <div class="ml-1">
            <b-button v-ripple.400="'rgba(234, 84, 85, 0.15)'" variant="outline-primary" class="mt-0"
              @click="refreshPage()">
              <feather-icon icon="SearchIcon" class="mr-25" />
              <span>Search</span>
            </b-button>
          </div>
        </div>

        <div>
          <b-button v-ripple.400="'rgba(234, 84, 85, 0.15)'" variant="primary" class="mt-0 mt-md-2"
            @click="createUser()">
            <feather-icon icon="EditIcon" class="mr-25" />
            <span>Input New</span>
          </b-button>
        </div>
      </div>


    </b-card-body>

    <!-- table -->
    <b-table ref="selectableTable" selectable :items="items" :fields="fields" responsive class="mb-0"
      @row-selected="onRowSelected">

      <template #cell(action)="data">
        <b-dropdown variant="link" no-caret toggle-class="p-0" right>
          <template #button-content>
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="btn-icon">
              <feather-icon icon="SettingsIcon" />
            </b-button>
          </template>

          <b-dropdown-item @click="updateUser(data.item)">
            <feather-icon icon="EditIcon" size="16" />
            <span class="align-middle ml-50">Update</span>
          </b-dropdown-item>

          <b-dropdown-item @click="deleteUser(data.item)">
            <feather-icon icon="TrashIcon" size="16" />
            <span class="align-middle ml-50">Delete</span>
          </b-dropdown-item>


        </b-dropdown>
      </template>

    </b-table>

    <!-- Pagination -->
    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <div></div>
      <!--pagination -->
      <div class="demo-inline-spacing pt-0">
        <b-pagination v-model="currentPage" hide-goto-end-buttons :total-rows="rows" :per-page="perPage"
          @input="onPageChange" />
      </div>
    </b-card-body>

    <!-- Modal create & update user -->
    <b-modal id="modal-user" hide-footer @hidden="onReset(false)">
      <template #modal-title> <template v-if="id">Update</template> <template v-else>Create</template> User</template>

      <b-form @submit="submit">
        <b-col md="12" xl="12" class="mb-1">
          <!-- basic -->
          <b-form-group label="Nama" label-for="basicInput">
            <b-form-input id="nama_id" placeholder="Nama.." v-model="nama_panjang" required />
          </b-form-group>
        </b-col>

        <b-col md="12" xl="12" class="mb-1">
          <!-- basic -->
          <b-form-group label="Email" label-for="email_id">
            <b-form-input id="email_id" type="email" placeholder="Email.." v-model="email" required />
          </b-form-group>
        </b-col>

        <b-col md="12" xl="12" class="mb-1">
          <!-- basic -->
          <b-form-group label="Role" label-for="role_id">
            <b-form-select v-model="role" id="role_id" :options="options_role" size="sm" required />
          </b-form-group>
        </b-col>

        <b-col md="12" xl="12" class="mb-1">
          <!-- basic -->
          <b-form-group label="Fakultas" label-for="fakultas_id">
            <b-form-select v-model="fakultas" id="fakultas_id" :options="options_fakultas" size="sm" required />
          </b-form-group>
        </b-col>

        <b-col md="12" xl="12" class="mb-1">
          <!-- basic -->
          <b-form-group label="Jurusan" label-for="jurusan_id">
            <b-form-select v-model="jurusan" id="jurusan_id" :options="options_jurusan" size="sm" required />
          </b-form-group>
        </b-col>

        <b-col md="12" xl="12" class="mb-1">
          <!-- basic -->
          <b-form-group label="Password" label-for="password_id">
            <b-form-input id="password_id" type="password" placeholder="Password.." v-model="password"
              :required="id === null" />
          </b-form-group>
        </b-col>

        <b-button class="mt-3" variant="outline-primary" block type="submit">
          <feather-icon icon="SendIcon" /> Submit
        </b-button>
      </b-form>
    </b-modal>

    <!-- Modal confirm delete user -->
    <b-modal id="modal-delete-user" hide-footer @hidden="onReset(false)">
      <template #modal-title> Delete User </template>
      <div class="d-block text-center">
        <p>Apakah anda yakin, ingin menghapus user dengan email ini <b style="text-size: '14px'">{{ email }}</b>?</p>
      </div>
      <b-button class="mt-3" variant="outline-primary" block @click="submitDelete()">
        <feather-icon icon="SendIcon" /> Submit
      </b-button>
    </b-modal>
  </b-card-code>

</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BTable, BButton, BFormGroup, BAvatar, BBadge, BCardBody, BPagination, BFormTextarea,
  BButtonToolbar, BButtonGroup, BDropdown, BDropdownItem, BFormInput, BRow, BCol, BModal, BFormSelect, BForm
} from 'bootstrap-vue'
import API from '@/api'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import handler from '@/api/handler'

export default {
  components: {
    BCardCode,
    BTable,
    BButton,
    BAvatar,
    BCardBody,
    BBadge,
    vSelect,
    BPagination,
    BButtonToolbar,
    BButtonGroup,
    BButton,
    BDropdown,
    BDropdownItem,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BModal,
    BFormTextarea,
    BFormSelect,
    BForm
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      currentPage: 1,
      rows: 0,
      perPage: 20,
      fields: ['id',
        {
          key: 'nama_panjang',
          label: 'Nama',
          sortable: true,
          sortKey: 'nama_panjang',

        },
        'email', 'action'],
      /* eslint-disable global-require */
      items: [],
      /* eslint-disable global-require */
      search: null,

      options_role: [
        { value: '2', text: 'Admin' },
        { value: '7', text: 'Admin Fakultas' }
      ],
      options_fakultas: [],
      options_jurusan: [],

      id: null,
      nama_panjang: '',
      email: '',
      role: null,
      fakultas: '',
      jurusan: '',
      password: '',
    }
  },
  methods: {
    async getUser() {
      try {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', true)

        const form = {
          limit: this.perPage,
          page: this.currentPage,
          search: this.search,
          is_pagination: true,
          sort_by: "created_at",
          sort_order: 'desc'
        }
        const { data } = await API.user.list(form)
        this.data_table = data.data
        this.items = data.data
        this.rows = data.pagination.total

        this.handleMsgSuccess('Berhasil tampilkan data log')
      } catch (error) {
        console.log(error)
        this.handleMsgErrors(error, 'Terjadi kesalahan silahkan coba lagi!')
      } finally {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', false)
      }

    },
    async getFakultas() {
      try {
        const { data } = await API.master.fakultaslist()
        this.options_fakultas = data.data.map((item) => {
          return {
            value: item.id,
            text: item.nama_fakultas
          }
        })
      } catch (error) {
        console.log(error)
        this.handleMsgErrors(error, 'Terjadi kesalahan silahkan coba lagi!')
      }
    },
    async getJurusan() {
      try {
        const { data } = await API.master.jurusanlist()
        this.options_jurusan = data.data.map((item) => {
          return {
            value: item.id,
            text: item.nama_jurusan
          }
        })
      } catch (error) {
        console.log(error)
        this.handleMsgErrors(error, 'Terjadi kesalahan silahkan coba lagi!')
      }
    },
    async getJurusanById(id) {
      try {
        const { data } = await API.master.jurusanByFakultasId(id)
        this.options_jurusan = data.data.map((item) => {
          return {
            value: item.id,
            text: item.nama_jurusan
          }
        })
      } catch (error) {
        console.log(error)
        this.handleMsgErrors(error, 'Terjadi kesalahan silahkan coba lagi!')
      }
    },
    onRowSelected(items) {
      this.selected = items
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected()
    },
    refreshPage() {
      this.updateQueryParams()
      if (this.currentPage == 1) {
        this.getUser()
      }
      else {
        this.currentPage = 1
      }

    },
    createUser() {
      this.$bvModal.show("modal-user")
    },
    async updateUser(dataUser) {
      this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', true)
      try {
        const { data } = await API.user.getById(dataUser.id)
        const item = data.data
        this.id = item.id
        this.nama_panjang = item.nama_panjang
        this.email = item.email
        this.role = parseInt(item.roles?.[0]?.id)
        this.fakultas = item.pendidikan?.[0]?.fakultas.id
        this.jurusan = item.pendidikan?.[0]?.jurusan.id
        this.$bvModal.show("modal-user")
      } catch (error) {
        console.log(error)
        this.handleMsgErrors(error, 'Terjadi kesalahan silahkan coba lagi!')
      } finally {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', false)
      }
    },
    deleteUser(item) {
      this.id = item.id
      this.email = item.email
      this.$bvModal.show("modal-delete-user")
    },
    async submitDelete() {
      try {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', true)
        await API.user.delete(this.id)
        this.handleMsgSuccess('Berhasil delete user')
        this.$bvModal.hide("modal-delete-user")
        this.onReset();
      } catch (error) {
        console.log(error)
        this.handleMsgErrors(error, 'Terjadi kesalahan silahkan coba lagi!')
      } finally {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', false)
      }
    },
    async submit(e) {
      e.preventDefault();
      this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', true)
      try {
        let form = {
          nama_panjang: this.nama_panjang,
          email: this.email,
          roles: [parseInt(this.role)],
          fakultas: this.fakultas,
          jurusan: this.jurusan,
          password: this.password
        }
        if (this.id !== null) {
          form = {
            ...form,
            id: this.id
          }
        }
        // await this.encryptRequest(API.user.create(form))
        await API.user.createUpdate(form)

        this.onReset();
        this.handleMsgSuccess('Berhasil Create Universitas');
        this.$bvModal.hide("modal-user")
      } catch (error) {
        console.log(error)
        this.handleMsgErrors(error, 'Terjadi kesalahan silahkan coba lagi!')
      }
      finally {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', false)
      }
    },
    onReset(onRefresh = true) {
      this.nama_panjang = '';
      this.email = '';
      this.role = null;
      this.fakultas = '';
      this.jurusan = '';
      this.password = '';
      this.id = null;
      if (onRefresh) {
        this.getUser();
        this.$router.push({ name: 'user' });
      }
    },
    onSortChanged(ctx) {
      this.currentPage = 1
      this.getUser()
      this.updateQueryParams()
    },

    updateQueryParams() {
      const query = {}

      if (this.search) query.search = this.search

      this.$router.replace({ query }).catch(() => { })
    },

    initFiltersFromQuery() {
      const query = this.$route.query
      if (query.search) this.search = query.search
    },
    onPageChange(page) {
      this.$router.push({ query: { ...this.$route.query, page } });
    },

  },
  mounted() {
    this.getFakultas();
    this.initFiltersFromQuery()
  },
  watch: {
    '$route.query.page': {
      immediate: true,
      handler(newVal) {
        this.currentPage = parseInt(newVal) || 1
        this.getUser()
      }
    },
    fakultas: {
      async handler() {
        await this.getJurusanById(this.fakultas)
      }, deep: true
    }

  }
}
</script>

<style lang="scss">
.b-table-selectable {
  .feather {
    font-size: 1.3rem;
  }
}
</style>
